import React, { useEffect, useState, useContext } from 'react';
import Axiosfetch from '../Common/Axiosfetch';
import Header from '../Header/AppHeader';
import '../DashBoard/DashboardStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faChartPie, faSearch } from '@fortawesome/free-solid-svg-icons';
import Regions from '../Common/Region';
import { ThemeContext } from '../Common/ThemeProvider';

const InvoiceReminder = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [RegionSymbol, setRegionSymbol] = useState({});
    const [InvoiceData, setInvoices] = useState([]);
    const [Showcards, setShowcards] = useState(true);
    const [FilterInvoice, setFilterInvoice] = useState([]);

    useEffect(() => {
        FetchInvoiceReminders(moment(new Date()).startOf('day').format('MM/DD/YYYY, HH:mm:ss'));

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchInvoiceReminders = (date) => {
        Axiosfetch(baseURL + "GetInvoiceReminders", "POST", { startDate: date }, InvoiceDataSuccess, Failure);
    };

    const InvoiceDataSuccess = (data) => {
        if (data.length > 0) {
            setInvoices(data);
            setFilterInvoice(data);
        }
        else {
            setInvoices([]);
            setFilterInvoice([]);
        }
    };

    const OnCheckedChange = () => {
        setShowcards(!Showcards);
    };

    const onInvoiceSearch = (e) => {
        let searchValue = e.target.value;
        if (searchValue !== "") {
            let invoiceSearchData = InvoiceData.filter(c => c.Quotation.Customer.Name.toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterInvoice(invoiceSearchData);
        }
        else {
            setFilterInvoice(InvoiceData);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show" style={{ marginBottom: "0.8rem" }}>
                <div className="row">
                    <div className="offset-md-3 col-md-5 col-sm-5">
                        <div className="align-center" style={{ fontWeight: "500", fontSize: "25px" }}>Invoice Reminders</div>
                    </div>
                    <div className="col-md-3 col-sm-3" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search By Customer..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onInvoiceSearch(e)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-1 align-center" style={{ margin: "auto" }}>
                        <span data-tip={(Showcards ? "Table View" : "Card View")} className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={OnCheckedChange}>
                            <FontAwesomeIcon icon={(Showcards ? faTable : faChartPie)} />
                        </span>
                    </div>
                </div>
                <div className="PageHeight" style={{ scrollbarColor: "#005582 transparent" }}>
                    <div className="row" style={{ paddingRight: "12px", display: (Showcards === true ? "flex" : "none") }}>
                        {FilterInvoice.length > 0 && FilterInvoice.map(invoice => (
                            <div className="col-md-3">
                                <div className="card cardMargin nonSelectable  CardhoverStyle align-center" style={{ border: "1px solid #ccc" }}>
                                    <div style={{ padding: "10px" }}>
                                        Invoice/{invoice.Quotation.Customer.Name.split(' ')[0].trim()}/#{invoice.ID}/{moment(invoice.CreatedDate).local().format("DDMMYYYY")}
                                    </div>
                                    <div>
                                        <div style={{ backgroundColor: "#d7efe6" }}>{moment(invoice.CreatedDate).local().format("DD MMMM YYYY")}</div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div title={invoice.Quotation.Customer ? invoice.Quotation.Customer.Name : ""} className="ellipseInvoiceStyle" style={{ fontWeight: "300", fontSize: "22px", minWidth: "175px" }}>
                                                    {invoice.Quotation.Customer ? invoice.Quotation.Customer.Name : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>

                                        <div style={{ backgroundColor: "#f8b3ae", color: "red" }}>
                                            {RegionSymbol.Symbol && (<FontAwesomeIcon style={{ marginRight: "5px", fontSize: "1.7rem" }} className="padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                            {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px", marginRight: "5px" }}>{RegionSymbol.Currency}</div>)}
                                            <span style={{ fontWeight: "300", fontSize: "32px" }}>{invoice.InvoiceNotes ? (invoice.InvoiceNotes[invoice.InvoiceNotes.length - 1].Balance).toFixed(2) : ""}</span></div>
                                    </div>
                                </div>

                            </div>
                        ))}
                    </div>
                    <div className="row" style={{ padding: "15px", display: (Showcards === false ? "block" : "none") }} >
                        <div className="col-md-12">
                            <table className="table table-striped">
                                <thead className="StickyHeader">
                                    <tr>
                                        <th style={{ width: "280px" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Invoice #</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Customer</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Amount Paid</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Balance</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Create Date</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "14px" }}>
                                    {
                                        FilterInvoice.length > 0 && FilterInvoice.map(Invoice => (
                                            <tr key={Invoice.ID} className="textCenter">
                                                <td style={{ maxWidth: "280px", wordWrap: "break-word" }}>Invoice/{Invoice.Quotation.Customer ? Invoice.Quotation.Customer.Name.split(' ')[0].trim() : ""}/#{Invoice.ID}/{moment(Invoice.CreatedDate).local().format("DDMMYYYY")}</td>
                                                <td className="tdtableProductStyleQuotationrecord">{Invoice.Quotation.Customer ? Invoice.Quotation.Customer.Name : ""}</td>
                                                <td>{Invoice.InvoiceNotes ? (Invoice.Quotation.TotalAmount - Invoice.InvoiceNotes[Invoice.InvoiceNotes.length - 1].Balance).toFixed(2) : ""}</td>
                                                <td>{Invoice.InvoiceNotes ? (Invoice.InvoiceNotes[Invoice.InvoiceNotes.length - 1].Balance).toFixed(2) : ""}</td>
                                                <td>{moment(Invoice.CreatedDate).local().format("DD MMMM YYYY hh:mm:ss A")}</td>
                                            </tr>
                                        ))
                                    }
                                    {
                                        FilterInvoice.length === 0 && (<tr className="textCenter">
                                            <td colSpan="8">
                                                There are no Invoices
                                            </td>
                                        </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default InvoiceReminder;